(function () {
  var sections = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"];
  var unlockStateKey = "dermoia-cart-gift-unlocked";
  var pendingGiftCelebrationKey = "dermoia-cart-gift-added";
  var reconciling = false;
  var addingOffer = false;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-cart-offers]"));
  }

  function config() {
    var offerRoots = roots();
    var root = offerRoots[0];
    if (!root) return null;
    var excludedIds = [];
    var eligibleGiftVariantIds = [];
    offerRoots.forEach(function (offerRoot) {
      excludedIds = excludedIds.concat((offerRoot.dataset.excludedOriginalProductIds || "").match(/\d+/g) || []);
      eligibleGiftVariantIds = eligibleGiftVariantIds.concat((offerRoot.dataset.eligibleGiftVariantIds || "").match(/\d+/g) || []);
    });
    return {
      gifts: root.dataset.giftsEnabled === "true",
      threshold: Number(root.dataset.giftThreshold || 0),
      giftUnlockAnimation: root.dataset.giftUnlockAnimation === "true",
      giftAddedAnimation: root.dataset.giftAddedAnimation === "true",
      upsells: root.dataset.upsellsEnabled === "true",
      eligibleGiftVariantIds: eligibleGiftVariantIds,
      excludedOriginalProductIds: excludedIds
    };
  }

  function render(state) {
    var drawer = document.querySelector("cart-notification");
    if (drawer && state.sections) drawer.renderContents(state);
  }

  async function request(url, body) {
    var response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error("Cart request failed");
    return response.json();
  }

  function disableOfferButtons(disabled) {
    document.querySelectorAll("[data-cart-offer-add]").forEach(function (button) {
      button.disabled = disabled;
    });
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function addSparkles(target, small) {
    if (!target || reducedMotion()) return;
    var burst = document.createElement("span");
    burst.className = "cart-gift-sparkles" + (small ? " cart-gift-sparkles--small" : "");
    burst.setAttribute("aria-hidden", "true");
    for (var index = 0; index < (small ? 7 : 12); index += 1) {
      var sparkle = document.createElement("i");
      sparkle.style.setProperty("--sparkle-index", index);
      sparkle.style.setProperty("--sparkle-angle", ((360 / (small ? 7 : 12)) * index) + "deg");
      sparkle.style.setProperty("--sparkle-distance", (small ? 34 + (index % 3) * 5 : 48 + (index % 4) * 7) + "px");
      burst.appendChild(sparkle);
    }
    target.appendChild(burst);
    window.setTimeout(function () { burst.remove(); }, 1100);
  }

  function animateGiftSections(className, small) {
    document.querySelectorAll("[data-gift-celebration-target]").forEach(function (section) {
      section.classList.remove(className);
      void section.offsetWidth;
      section.classList.add(className);
      addSparkles(section, small);
      window.setTimeout(function () { section.classList.remove(className); }, 1200);
    });
  }

  function showGiftToast() {
    document.querySelectorAll(".cart-gift-toast").forEach(function (toast) { toast.remove(); });
    var host = document.querySelector(".cart-notification") || document.querySelector("main") || document.body;
    var toast = document.createElement("div");
    toast.className = "cart-gift-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    var root = roots()[0];
    var message = root && root.dataset.giftAddedMessage ? root.dataset.giftAddedMessage : "Your FREE gift has been added!";
    var sparkle = document.createElement("span");
    var text = document.createElement("strong");
    sparkle.setAttribute("aria-hidden", "true");
    sparkle.textContent = "✦";
    text.textContent = message;
    toast.appendChild(sparkle);
    toast.appendChild(text);
    host.appendChild(toast);
    window.setTimeout(function () { toast.classList.add("cart-gift-toast--visible"); }, 20);
    window.setTimeout(function () {
      toast.classList.remove("cart-gift-toast--visible");
      window.setTimeout(function () { toast.remove(); }, 250);
    }, 2800);
  }

  function celebrateGiftAdded() {
    animateGiftSections("cart-offers__gifts--gift-added", true);
    showGiftToast();
  }

  function syncGiftCelebrationState() {
    var offerRoots = roots();
    if (!offerRoots.length) {
      storageSet(unlockStateKey, "false");
      return;
    }
    var qualified = offerRoots.some(function (root) {
      return root.dataset.giftQualified === "true";
    });
    var wasQualified = storageGet(unlockStateKey) === "true";
    if (qualified && !wasQualified) {
      storageSet(unlockStateKey, "true");
      if (offerRoots.some(function (root) { return root.dataset.giftUnlockAnimation === "true"; })) {
        animateGiftSections("cart-offers__gifts--unlock-celebration", false);
      }
    } else if (!qualified) {
      storageSet(unlockStateKey, "false");
    }

    if (storageGet(pendingGiftCelebrationKey) === "true") {
      storageRemove(pendingGiftCelebrationKey);
      if (offerRoots.some(function (root) { return root.dataset.giftAddedAnimation === "true"; })) {
        celebrateGiftAdded();
      }
    }
  }

  async function reconcile() {
    if (reconciling) return false;
    var settings = config();
    if (!settings) return false;
    reconciling = true;
    try {
      var cart = await fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (response) {
        return response.json();
      });
      var normalProductIds = {};
      var excludedOriginalProductIds = {};
      var eligibleGiftVariantIds = {};
      var subtotal = 0;

      settings.excludedOriginalProductIds.forEach(function (productId) {
        excludedOriginalProductIds[Number(productId)] = true;
      });
      settings.eligibleGiftVariantIds.forEach(function (variantId) {
        eligibleGiftVariantIds[Number(variantId)] = true;
      });
      cart.items.forEach(function (item) {
        var type = item.properties && item.properties._cart_offer_type;
        if (type !== "gift") subtotal += item.final_line_price;
        if (!type) {
          normalProductIds[item.product_id] = true;
          excludedOriginalProductIds[item.product_id] = true;
        }
      });

      var updates = {};
      var keptGift = false;
      var keptUpsellOriginalIds = {};
      cart.items.forEach(function (item) {
        var properties = item.properties || {};
        if (properties._cart_offer_type === "gift") {
          if (!settings.gifts || !eligibleGiftVariantIds[item.variant_id] || subtotal < settings.threshold || keptGift) updates[item.key] = 0;
          else {
            keptGift = true;
            if (item.quantity !== 1) updates[item.key] = 1;
          }
        }
        if (properties._cart_offer_type === "upsell") {
          var triggerId = Number(properties._cart_trigger_product_id);
          var originalId = Number(properties._cart_original_product_id);
          if (
            !settings.upsells ||
            !normalProductIds[triggerId] ||
            excludedOriginalProductIds[originalId] ||
            keptUpsellOriginalIds[originalId]
          ) {
            updates[item.key] = 0;
          } else {
            keptUpsellOriginalIds[originalId] = true;
            if (item.quantity !== 1) updates[item.key] = 1;
          }
        }
      });

      if (!Object.keys(updates).length) return false;
      var state = await request("/cart/update.js", {
        updates: updates,
        sections: sections,
        sections_url: window.location.pathname
      });
      if (window.location.pathname === "/cart") window.location.reload();
      else render(state);
      return true;
    } finally {
      reconciling = false;
    }
  }

  async function addOffer(button) {
    if (addingOffer) return;
    addingOffer = true;
    disableOfferButtons(true);
    button.classList.add("loading");
    var type = button.dataset.offerType;
    var properties = { "_cart_offer_type": type };
    if (type === "upsell") {
      properties._cart_trigger_product_id = button.dataset.triggerProductId;
      properties._cart_original_product_id = button.dataset.originalProductId;
    }
    try {
      var state = await request("/cart/add.js", {
        id: Number(button.dataset.variantId),
        quantity: 1,
        properties: properties,
        sections: sections,
        sections_url: window.location.pathname
      });
      if (type === "gift") storageSet(pendingGiftCelebrationKey, "true");
      if (window.location.pathname === "/cart") {
        window.location.reload();
        return;
      }
      render(state);
      await reconcile();
      if (type === "gift") {
        storageRemove(pendingGiftCelebrationKey);
        var currentSettings = config();
        if (currentSettings && currentSettings.giftAddedAnimation) celebrateGiftAdded();
      }
    } catch (error) {
      console.error(error);
      disableOfferButtons(false);
      button.classList.remove("loading");
    } finally {
      addingOffer = false;
    }
  }

  document.addEventListener("click", function (event) {
    var offerButton = event.target.closest("[data-cart-offer-add]");
    if (offerButton) {
      event.preventDefault();
      addOffer(offerButton);
      return;
    }
    var checkout = event.target.closest('[name="checkout"], a[href="/checkout"], .additional-checkout-buttons');
    if (checkout && !checkout.dataset.offerValidated) {
      event.preventDefault();
      reconcile().then(function () {
        checkout.dataset.offerValidated = "true";
        if (checkout.tagName === "A") window.location.href = checkout.href;
        else checkout.click();
      });
    }
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    syncGiftCelebrationState();
    reconcile();
    var cartHost = document.querySelector("cart-notification") || document.body;
    new MutationObserver(syncGiftCelebrationState).observe(cartHost, { childList: true, subtree: true });
  });

  window.DermoiaCartOffers = { reconcile: reconcile };
}());
